<template>
  <div>
    <v-container class="grey lighten-5">
      <v-row no-gutters class="pagination-table-header">
        <v-col col="12">
          <v-overlay :absolute="true" :value="isComponentLoading">
            <v-progress-circular indeterminate size="24"></v-progress-circular>
          </v-overlay>
          <v-card
            v-if="L.isEmpty(paginatedObject) || L.isEmpty(paginatedObject.data)"
            class="pa-3"
          >
            <p class="text-center mt-2">
              <v-icon>mdi-account-search-outline</v-icon>
              <b
                >&nbsp;&nbsp;{{
                  lang($store, 'sap/listings.orders.not_found')
                }}&nbsp;&nbsp;</b
              >
              <v-icon>mdi-account-badge-outline</v-icon>
            </p>
          </v-card>
          <div v-else class="mt-4">
            <v-row>
              <v-col
                v-for="(item, key) in paginatedObject.data"
                :key="'col_' + key + item.uuid"
                cols="12"
                lg="3"
                md="4"
                sm="6"
                class="py-1"
              >
                <v-card
                  class="pa-1"
                  :style="{
                    background: cardColor(item)
                  }"
                >
                  <div>
                    <div v-if="item.contact.address_premises_type==OFFICE && item.order_base_type==OFFICE" class="d-flex flex-row justify-end">
                      <div cols="8" class="time-limit caption grey lighten-4 pa-1">
                        <v-icon>mdi-clock-outline</v-icon> {{ item.contact.address_time_limit != null && item.contact.address_time_limit != '' ? item.contact.address_time_limit : 'не задано'  }}
                      </div>
                    </div>
                    <div class="overline text-center">
                      {{
                        lang(
                          $store,
                          `sap/listings.global.filter.order_types.${item.order_base_type}`
                        )
                      }}
                    </div>
                    <contact-line :contact="item.contact" />
                    <v-divider />
                    <cleaners-line
                      @remove-cleaner="deleteCleaner(ORDERS_BASE, item, $event)"
                      :cleaners="item.cleaners"
                      :need-case-cleaning-started="true"
                      :cleaning-started="!!item.is_presence"
                    />
                    <cleaner-selector
                      v-if="isPossibleAddCleaner(item)"
                      :role="role"
                      @select="selectCleaner(ORDERS_BASE, item, $event)"
                      :disabled="false"
                      :hint="null"
                      :dateTime="item.datetime"
                    />
                    <v-divider />
                    <datetime-alert
                      v-if="item.datetime"
                      :datetime="moment(item.datetime)"
                      :update-request="updateSimpleRequest(item, 'datetime')"
                      @updated="
                        item.datetime = $event;
                        $store.dispatch('page/clearCache');
                        $forceUpdate();
                      "
                    />
                    <v-divider />
                    <premise-chip
                      :premises-type="
                        lang(
                          $store,
                          `sap/listings.global.filter.premises.${item.contact.address_premises_type}`
                        )
                      "
                      :small="true"
                    />
                    <span class="black--text caption">
                      {{ 'contact_address' in item ? item.contact_address : ''}}
                    </span>
                    <v-divider />
                    <hoover
                      style="vertical-align: sub"
                      fill="red"
                      v-if="
                        hooverModeEnable() && item.contact.address_is_hoover
                      "
                    />
                    <animals
                      fill="#F77B00"
                      style="vertical-align: sub"
                      v-if="item.contact.address_has_animals"
                    />
                    <icon-tooltip
                      v-if="item.contact.address_is_commerce"
                      icon="mdi-currency-usd"
                      text="Коммерция"
                      color="red"
                    />
                    <is-ok
                      :is-ok="item.is_contact_ok"
                      :update-request="
                        updateSimpleRequest(item, 'is_contact_ok')
                      "
                      @updated="
                        item.is_contact_ok = $event;
                        $forceUpdate();
                      "
                    />
                    <is-ok
                      icon="mdi-spray-bottle"
                      :is-ok="item.is_cleaner_ok"
                      :update-request="
                        updateSimpleRequest(item, 'is_cleaner_ok')
                      "
                      @updated="
                        item.is_cleaner_ok = $event;
                        $forceUpdate();
                      "
                    />
                    <is-presence
                      :is-ok="item.is_presence"
                      :update-request="updateSimpleRequest(item, 'is_presence')"
                      @updated="
                        item.is_presence = $event;
                        $forceUpdate();
                      "
                    />
                    <order-status
                      :value="item.order_status"
                      :update-request="
                        updateSimpleRequest(item, 'order_status')
                      "
                      @updated="
                        item.order_status = $event;
                        $forceUpdate();
                      "
                    />
                    <span v-if="item.is_cleaner_done">
                      &nbsp;
                      <v-icon
                        style="font-size: 18px; border-radius: 50%"
                        title="Клинер Закончил уборку"
                        class="black pa-1  theme--light success--text"
                      >
                        mdi-clock-end
                      </v-icon>
                    </span>
                    <span v-if="item.contact.address_additional_info">
                      <v-btn text icon @click="onPreview(item)">
                        <v-icon>mdi-eye</v-icon>
                      </v-btn>
                    </span>
                    <star-rating
                      v-if="!!item.review"
                      :rating="item.review.rating"
                      :read-only="true"
                      :star-size="20"
                      :show-rating="false"
                      inactive-color="#e9e9e9"
                    />
                    <color-divider
                      :order-type="item.order_base_type"
                      :subscription="!!item.is_subscription"
                      :order-source="item.source"
                    />
                    <div class="d-flex flex-row justify-space-between">
                      <div class="d-flex">
                        <router-link
                          :to="{
                            name: 'orders.base.show',
                            params: { orderUuid: item.uuid }
                          }"
                        >
                          <v-icon small>mdi-briefcase-edit-outline</v-icon>
                        </router-link>
                        <!--<edit-button @click="onItemEdit(item)"/>-->
                        <trash-button @click="onItemDelete(item)" />
                        <copy-button @click="onItemCopy(item)" />
                        <a
                          v-if="item.checklist_pdf"
                          target="_blank"
                          :href="item.checklist_pdf"
                          class="ml-4 text-decoration-none"
                        >
                          <v-icon color="red">mdi-file-pdf-box</v-icon>
                        </a>
                        <comment-input
                          :value="item.minicomment"
                          :update-request="
                            updateSimpleRequest(item, 'minicomment')
                          "
                          @updated:text="
                            item.minicomment = $event;
                            $forceUpdate();
                          "
                        />
                      </div>
                    </div>
                    <div class="d-flex flex-row">
                      <comment-input
                        class="w-100"
                        :value="item.minicomment2"
                        :update-request="
                          updateSimpleRequest(item, 'minicomment2')
                        "
                        @updated:text="
                          item.minicomment2 = $event;
                          $forceUpdate();
                        "
                      />
                      <clone-button
                        title="Клонирование заказа"
                        @click="onItemClone(item)"
                      />
                    </div>
                    <div
                      class="d-flex flex-wrap red--text"
                      v-if="item.contact.discount_value"
                    >
                      <span class="font-weight-bold pl-2">
                        Скидка: {{ item.contact.discount_value }}
                        {{ item.contact.discount_is_money ? ' грн.' : ' %' }}
                      </span>
                      <span
                        class="pl-2 black--text caption"
                        v-if="item.contact.discount_note"
                        >({{ item.contact.discount_note }})</span
                      >
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
/* constants */
import hoover from '@/components/icons/hoover.vue';
import animals from '@/components/icons/animals.vue';
import IconTooltip from '@/components/minialerts/IconTooltip.vue';
import { ORDERS_BASE } from '@/constants/payable';
import * as sources from '~constants/sources';
import { CLEANER_BASE } from '@/constants/roles';
import * as order_statuses from '@/constants/order_statuses';
import { OFFICE } from '@/constants/promises';
import { office } from '@/constants/order_types';
/* utils */
import { roles as rolesColors } from '@/utils/listingColors';
/* mixins */
import isComponentLoading from '@/mixins/isComponentLoading';
import orderBaseUpdateSimpleProp from '@/mixins/orders/orderUpdateSimpleProp';
import orderListingCard from '@/mixins/orders/orderListingCard';
import settingsMixin from '@/mixins/settingsMixin';
/* components */
import StarRating from 'vue-star-rating';
import DatetimeAlert from '@/components/minialerts/DatetimeAlert.vue';
import ColorDivider from '@/components/minialerts/ColorDivider.vue';
import ContactLine from '@/components/minialerts/ContactLine.vue';
import CleanersLine from '@/components/minialerts/CleanersLine.vue';
import IsOk from '@/components/minialerts/IsOk.vue';
import IsPresence from '@/components/minialerts/IsPresence.vue';
import CopyButton from '@/components/minialerts/CopyButton.vue';
import TrashButton from '@/components/minialerts/TrashButton.vue';
import CloneButton from '@/components/minialerts/CloneButton.vue';
import CommentInput from '@/components/minialerts/CommentInput.vue';
import OrderStatus from '@/components/minialerts/OrderStatus.vue';
import PremiseChip from '@/components/minialerts/PremiseChip.vue';
import CleanerSelector from '@/components/autocomples/CleanerSelector.vue';
import OrderBaseProxy from '../../proxies/Order/OrderBaseProxy';

export default {
  name: 'TablePaginatedOrdersBase',
  components: {
    IsPresence,
    DatetimeAlert,
    ColorDivider,
    ContactLine,
    CleanersLine,
    IsOk,
    CopyButton,
    TrashButton,
    CloneButton,
    CommentInput,
    OrderStatus,
    PremiseChip,
    hoover,
    animals,
    StarRating,
    IconTooltip,
    CleanerSelector
  },
  mixins: [
    isComponentLoading,
    orderBaseUpdateSimpleProp,
    orderListingCard,
    settingsMixin
  ],
  props: {
    paginatedObject: {
      type: Object,
      default: () => {}
    },
    noActions: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      moment,
      ORDERS_BASE,
      rolesColors,
      sources,
      L: _,
      order_statuses,
      role: CLEANER_BASE,
      OFFICE,
      office
    };
  },
  computed: {
    account() {
      return this.$store.getters['account/account'];
    }
  },
  methods: {
    cardColor(item) {
      if (item.is_subscription && item.order_base_type === 'office') {
        return '#e01a1a1a';
      }
      if (item.is_subscription) {
        return '#0000001a';
      }
      return 'white';
    },
    isPossibleAddCleaner(order) {
      const duration = moment
        .duration(moment(order.datetime).diff(moment()))
        .asHours();
      return order.order_status !== this.order_statuses.DONE && duration >= 0;
    },
    onItemEdit(item) {
      this.$emit('edit-item', item);
    },
    onItemDelete(item) {
      this.$emit('delete-item', item);
    },
    onItemClone(item) {
      this.$emit('clone-item', item);
    },
    onItemCopy(item) {
      this.$emit('copy-item', item);
    },
    onPreview(item) {
      this.$emit('preview-item', item);
    },

    onAddressEdit(item, address) {
      this.$emit('edit-address', {
        item,
        address
      });
    },
    onAddressDelete(item, address) {
      this.$emit('delete-address', {
        item,
        address
      });
    }
  }
};
</script>

<style lang="sass" scoped>
.table-action
  &:hover
    fill: #0066ff
    transition: fill 0.5s
    cursor: pointer

.time-limit
  max-width: 65%
  max-height: 30px
  overflow: hidden
</style>
